


















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class CabinClassTravelersDropList extends Vue {
  @Prop() private adults!: number;
  @Prop() private childrens!: number;
  @Prop() private infants!: number;
  @Prop() private passengerDecrement: Function;
  @Prop() private passengerIncrement: Function;
  @Prop() private selectedClass!: Function;
  @Prop() private selectedClassValue!: string;
  @Prop() private search!: Function;
  @Prop() private olderPassengers: number;
}
